// extracted by mini-css-extract-plugin
export default {"tooltip":"WrapperWithHoverableTooltip_tooltip__8OXmL"};